import { default as latestEdits } from "components/Charts/LatestEdits/LatestEdits.reducer";
import autocomplete from "components/Form/components/Autocomplete/Autocomplete.reducer";
import referenceLabels from "components/Form/components/ReferenceLabel/ReferenceLabel.reducer";
import listing from "components/Listing/Listing.reducer";
import { default as plugins } from "components/PluginsPopover/Plugin.reducer";
import pendingActions from "components/Prompt/PendingActions.reducer";
import provisioningState from "components/ProvisioningStateDot/ProvisioningState.reducer";
import auth from "containers/Auth/Auth.reducer";
import identityRole from "containers/Auth/screens/IdentityManagement/IdentityRole.reducer";
import bundleManager from "containers/BundleManager/Bundles.reducer";
import bundleRepositories from "containers/BundleRepositories/BundleRepositories.reducer";
import bundles from "containers/Bundles/Bundles.reducer";
import executions from "containers/Executions/Executions.reducer";
import messages from "containers/Messages/Messages.reducer";
import projects from "containers/Projects/Projects.reducer";
import nonProjectRecords from "containers/Projects/components/ProjectTree/NonProjectRecords/NonProjectRecords.reducer";
import resources from "containers/Resources/Resources.reducer";
import wrappers from "containers/Resources/screens/ResourcesSingle/components/ResourceWrapper/WrapperList.reducer";
import dependencyVisualization from "containers/Resources/screens/ResourcesSingle/components/Visualization/DependencyVisualization/dependencyVisualization.reducer";
import stats from "containers/Stats/Stats.reducer";
import upload from "containers/Upload/Upload.reducer";
import workspaceConfig from "containers/WorkspaceConfig/WorkspaceConfig.reducer";
import workspaceSettings from "containers/WorkspaceSettings/WorkspaceSettings.reducer";
import workspaces from "containers/Workspaces/Workspaces.reducer";
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import dataStore from "utils/DataStore/DataStore.reducer";
import notificationManager from "utils/NotificationManager/NotificationManager.reducer";

// Persist ONLY the `objectTemplateSchema` slice of `dataStore` across reloads.
// The object-template schema (id/name/icon/schema per template) is near-static
// and is pushed as a full snapshot on every `/ui` websocket connect. Caching it
// client-side lets custom-object icons (and the create-new menu / advanced
// search / filter builder that resolve from this store) render immediately on a
// cold load — before the heavy snapshot arrives — instead of showing the
// type-default glyph until the socket repopulates the store. The socket snapshot
// overwrites the rehydrated value on connect, so a changed template icon
// self-corrects on the next load. The whitelist is scoped to this one slice
// deliberately: the rest of `dataStore` holds volatile live frames
// (trashState, gitWriteLock, bundle_state, gitLogPlainList, connectorInputSchemas,
// schema) that must stay fresh from the socket and must NOT be restored stale.
const persistedDataStore = persistReducer(
    { key: "dataStore", storage, whitelist: ["objectTemplateSchema"] },
    dataStore
);

//  Combining all existing reducers
const appReducer = combineReducers({
    //  Core
    auth,
    notificationManager,
    listing,
    //  App
    projects,
    bundles,
    nonProjectRecords,
    messages,
    upload,
    workspaces,
    workspaceConfig,
    workspaceSettings,
    stats,
    resources,
    executions,
    autocomplete,
    referenceLabels,
    plugins,
    wrappers,
    latestEdits,
    identityRole,
    bundleManager,
    bundleRepositories,
    dependencyVisualization,
    dataStore: persistedDataStore,
    provisioningState,
    pendingActions,
});

const rootReducer = (state, action) => {
    if (action.type === "SIGN_OUT_SUCCESSFUL") {
        // The persist key is configured as "state" in store/index.js, so redux-persist
        // writes to localStorage under "persist:state" — not the default "persist:root".
        storage.removeItem("persist:state");
        // Also drop the nested dataStore persist key (objectTemplateSchema cache)
        // so a signed-out / switched user does not rehydrate the previous user's
        // template set.
        storage.removeItem("persist:dataStore");
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;
